import orderApi from '../../api/order'
import * as types from '../mutation-types'

// initial state
const state = {
  commissions: [],
  commissionType: '',
  dateScope: '0',
  date: '',
  // 奖励类型
  commissionTypeKeys: [
  ],
  // 选择时间周期
  dateScopeKeys: [
    // {key: '全部', value: 'DATE_ALL'},
    // {key: '近7日', value: 'DATE_SEVEN'},
    // {key: '近30天', value: 'DATE_THIRTY'},
    // {key: '近半年', value: 'DATE_SIX_MONTH'}
    {
      value: '0',
      key: '全部'
    },
    {
      value: '1',
      key: '选择日期'
    }
  ],
  totalMoney: 0,
  pageSize: 10,
  pageIndex: 1,
  maxPageSize: 1,
  secondPlatformAgentId: ''
}

// getters
const getters = {
  commissions: state => state.commissions,
  commissionType: state => state.commissionType,
  dateScope: state => state.date && state.date !== '' ? '1' : '0',
  commissionTypeKeys: state => state.commissionTypeKeys,
  dateScopeKeys: state => state.dateScopeKeys,
  totalMoney: state => state.totalMoney,
  isCommissionPageEnd: state => state.pageIndex >= state.maxPageSize
}
// mutations
const mutations = {
  // 设置奖励列表
  [types.RECEIVE_ACCOUNT_COMMISSION_LIST] (state, { list }) {
    state.commissions = list
  },
  // 追加奖励列表
  [types.APPEND_ACCOUNT_COMMISSION_LIST] (state, {list}) {
    if (list && list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        state.commissions.push(list[i])
      }
    }
    console.log('追加奖励列表')
  },
  // 设置奖励类型
  [types.SET_ACCOUNT_COMMISSION_TYPE] (state, {commissionType}) {
    state.commissionType = commissionType
  },
  // 设置奖励类型List
  [types.SET_ACCOUNT_COMMISSION_TYPE_KEYS] (state, {commissionTypeKeys}) {
    state.commissionTypeKeys = commissionTypeKeys
  },
  // 设置奖励时间周期
  [types.SET_ACCOUNT_COMMISSION_DATESCOPE] (state, {dateScope}) {
    state.dateScope = dateScope
  },
  // 设置奖励总金额
  [types.RECEIVE_ACCOUNT_COMMISSION_TOTALMONEY] (state, {totalMoney}) {
    state.totalMoney = totalMoney
  },
  // 设置最大页数
  [types.SET_ACCOUNT_COMMISSION_MAXPAGESIZE] (state, {pageCount}) {
    state.maxPageSize = pageCount
  },
  // 设置当前页数
  [types.SET_ACCOUNT_COMMISSION_PAGEINDEX] (state, {pageIndex}) {
    state.pageIndex = pageIndex
  },
  SET_ACCOUNT_COMMISSION_DATE (state, date) {
    state.date = date
  },
  SET_ACCOUNT_COMMISSION_SECOND_PLATFORMAGENTID (state, secondPlatformAgentId) {
    state.secondPlatformAgentId = secondPlatformAgentId
  }
}

// actions
const actions = {
  getCommissions ({ commit, getters }) {
    commit(types.SET_ACCOUNT_COMMISSION_PAGEINDEX, { pageIndex: 1 })
    let promise = orderApi.getCommission(
      {
        commissionType: getters.commissionType,
        // dateScope: getters.dateScope,
        date: state.date,
        pageSize: state.pageSize,
        pageIndex: state.pageIndex,
        secondPlatformAgentId: state.secondPlatformAgentId
      }).then(res => {
        commit(types.SET_ACCOUNT_COMMISSION_MAXPAGESIZE, {pageCount: res.data.result.list.pageCount})
        commit(types.SET_ACCOUNT_COMMISSION_TYPE_KEYS, {commissionTypeKeys: res.data.result.list.commissionType})
        commit(types.RECEIVE_ACCOUNT_COMMISSION_TOTALMONEY, {totalMoney: res.data.result.list.totalMoney})
        let list = res.data.result.list.settlementOrder
        commit(types.RECEIVE_ACCOUNT_COMMISSION_LIST, { list: list })
      })
    return promise
  },
  // 设置奖励类型
  setCommissionType ({commit, getters}, payload) {
    commit(types.SET_ACCOUNT_COMMISSION_TYPE, {commissionType: payload.commissionType})
    return this.dispatch('getCommissions', {commit, getters})
  },
  // 设置奖励时间周期
  setCommissionDateScope ({commit, getters}, payload) {
    commit(types.SET_ACCOUNT_COMMISSION_DATESCOPE, {dateScope: payload.dateScope})
    console.log(this)
    return this.dispatch('getCommissions', {commit, getters})
  },
  setCommissionDate ({commit, getters}, date) {
    commit('SET_ACCOUNT_COMMISSION_DATE', date)
    return this.dispatch('getCommissions', {commit, getters})
  },
  // 加载更多
  loadMoreCommissions ({commit, getters}) {
    const pageNo = state.pageIndex + 1
    commit(types.SET_ACCOUNT_COMMISSION_PAGEINDEX, { pageIndex: pageNo })
    let promise = orderApi.getCommission(
      {
        commissionType: getters.commissionType,
        // dateScope: getters.dateScope,
        date: state.date,
        pageSize: state.pageSize,
        pageIndex: state.pageIndex,
        secondPlatformAgentId: state.secondPlatformAgentId
      }).then(res => {
        if (!res) {
          return
        }
        console.log('commission resp', res.data)
        let list = res.data.result.list.settlementOrder
        commit(types.APPEND_ACCOUNT_COMMISSION_LIST, { list: list })
      })
    return promise
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/commission.js